import { ReactNode } from 'react'

import { LanguagesEnum } from 'common/enums/languages'
import { useAppInfo } from 'hooks/useAppInfo'
import { normalizeLanguage, resolveDeviceLanguage } from 'utils'
import { ErrorPage } from 'components/ErrorPage'

import { bridgeErrorMessages } from './constants'

type WebViewBridgeGuardProps = {
  children: ReactNode
}

export const WebViewBridgeGuard = ({ children }: WebViewBridgeGuardProps) => {
  const { appInfo, isLoading, isError, refetch } = useAppInfo()

  const selectedLanguage = normalizeLanguage(resolveDeviceLanguage(appInfo), LanguagesEnum.EN_US)

  const messages = bridgeErrorMessages[selectedLanguage]

  if (isLoading) {
    return null
  }

  if (isError) {
    return (
      <ErrorPage
        title={messages.bridgeFailure.title}
        description={messages.bridgeFailure.description}
        primaryButton={messages.bridgeFailure.primaryButton}
        secondaryButton={messages.bridgeFailure.secondaryButton}
        refetch={refetch}
      />
    )
  }

  return <>{children}</>
}
